// MA2's additions to GET /api/admin/rails/routes and /walls, typed by the shared contract and read unknown-safe.
import type { RoutesAdditions } from '@cobrain/admin-contract';
function field(raw: unknown, key: string): unknown {
  return raw !== null && typeof raw === 'object' && !Array.isArray(raw) ? (raw as Record<string, unknown>)[key] : undefined;
}
export function lockedRule(raw: unknown): RoutesAdditions['routes'][number]['locked'] {
  const value = field(raw, 'locked');
  return typeof value === 'string' ? value : null;
}
export function routeTotal(raw: unknown): RoutesAdditions['total'] | null {
  const value = field(raw, 'total');
  return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? value : null;
}

export function wallReason(raw: unknown): string | null {
  const value = field(raw, 'reason');
  return typeof value === 'string' ? value : null;
}
